/**
 * Подкручиваются ли боту броски d6 его уровнем бонуса (поля d6MinRoll и
 * d6RollBonus в configs/playerBonus; сейчас они есть только у «божества»).
 *
 * Только боту, который помечен ботом для всех: «явному» боту рейтингового
 * матча (isVisibleBot) и боту локальной партии (isLocalBot). Остальные кидают
 * честно при любом бонусе:
 *  - живые игроки, в том числе с бонусом локальной игры или сетевого лобби —
 *    им бонус дает только экономику и очки;
 *  - неявные боты рейтинговых партий — подкрутки костей по лиге у них больше
 *    нет (их бонус лиги остался в прошлом);
 *  - боты сетевого лобби с бонусом, кампании, обучения и демо.
 *
 * Признаки публичные и устойчивы к маскам серверного движка ботов: isBot
 * подменяют маски ручного управления (maskControlledBots) и автопилота, а
 * isVisibleBot / isLocalBot — нет, поэтому кости бота не меняются от того,
 * кто нажимает за него кнопки.
 *
 * @param {Object} [player] - игрок из состояния партии
 * @returns {boolean}
 */
export const checkIfBotHasBonusDice = (player) => Boolean(player && (player.isVisibleBot || player.isLocalBot));
